import React from 'react';
import {OrbitComponent} from '../../../../../base-components/orbit-component/orbit-component';
import {PreviewFeatureType} from '../../../../../../services/game-preview-features-selector/preview-features/game-preview-feature.interface';
import {Check} from '@sparkware/app-utils';
import {CellValueBoolBox} from './boxes/cell-value-bool/cell-value-bool.box';
import {CellValueTextBox} from './boxes/cell-value-text/cell-value-text.box';
import {CellTitleBox} from './boxes/cell-title/cell-title.box';

export interface GameFeaturePreviewCellComponentProps{
  title: string;
  type: PreviewFeatureType,
  value: any
}

export class GameFeatureCellComponent extends OrbitComponent<GameFeaturePreviewCellComponentProps> {

  private _renderNoInfo() {
    return (<CellValueTextBox className='cy-cell-no-info'>-</CellValueTextBox>);
  }
  private _renderCheckbox() {
    if(this.props.value) {
      return (<CellValueBoolBox className='cy-cell-value-bool'/>);
    }

    return this._renderNoInfo();
  }

  private _renderDescription() {
    if(Check.isEmpty(this.props.value)) {
      return this._renderNoInfo();
    }

    return (<CellValueTextBox className='cy-cell-value-text'>{this.props.value}</CellValueTextBox>);
  }


  private _renderValue() {
    if(this.props.type === PreviewFeatureType.check) {
      return this._renderCheckbox();
    }

    return this._renderDescription();
  }

  render() {
    return (
      <td>
        <CellTitleBox className='cy-cell-title'>{this.props.title}</CellTitleBox>
        {this._renderValue()}
      </td>
    );

  }
}
